import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BookmarkBoardMock } from "../../../components/Mockups/BookmarkBoardMock";

export const MultiCollection = () => {
  const { t } = useTranslation();
  return (
    <section id="multi-collection" className="container section-padding pb-0">
      <div className="row align-items-center">
        <div className="col-xl-6 col-lg-6 col-12">
          <h3 className="mb-3 fs-2 fw-bold mb-4">
            {t("home.multiCollection.title")}
          </h3>
          <p className="mb-4">{t("home.multiCollection.description")}</p>
          <ul className="list-unstyled mb-0 d-flex flex-column gap-3 mb-4 mb-md-4 mb-lg-0">
            <li className="d-flex flex-row gap-2">
              <i className="bi bi-check-circle-fill text-success"></i>
              <span>{t("home.multiCollection.benefits.multiAdd")}</span>
            </li>
            <li className="d-flex flex-row gap-2">
              <i className="bi bi-check-circle-fill text-success"></i>
              <span>{t("home.multiCollection.benefits.context")}</span>
            </li>
            <li className="d-flex flex-row gap-2">
              <i className="bi bi-check-circle-fill text-success"></i>
              <span>{t("home.multiCollection.benefits.noDuplicates")}</span>
            </li>
          </ul>
          <div className="mb-4 mb-lg-0 mt-4">
            <Link
              to="/features/multi-collection"
              className="btn btn-none p-0 text-purple d-inline-flex align-items-center gap-2"
            >
              {t("features.buttons.multiCollection")}
            </Link>
          </div>
        </div>
        <div className="col-xl-6 col-lg-6 col-12">
          <div className="bg-primary bg-opacity-10 p-3 p-md-4 rounded-4 flex-column justify-content-center d-flex ms-0 ms-lg-4">
            <BookmarkBoardMock />
          </div>
        </div>
      </div>
    </section>
  );
};
